/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Mild_Spicy_Fish_DashInputs */

const fr_mild_spicy_fish_dash = /** @type {(inputs: Mild_Spicy_Fish_DashInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer la catégorie "${i?.title}" ? Cette action
					est irréversible.`)
};

/**

* @param {Mild_Spicy_Fish_DashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mild_spicy_fish_dash = /** @type {((inputs: Mild_Spicy_Fish_DashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Spicy_Fish_DashInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mild_spicy_fish_dash(inputs)
});